module.exports = __webpack_public_path__ + "img/new_coursecover0615.b585b055.png";